import React, { useMemo, useState } from "react";
import { Box } from "@mui/material";
import ApartmentRoundedIcon from "@mui/icons-material/ApartmentRounded";

import Dialog from "../../../components/dialog/Dialog";
import { GetFacilitiesByOrganisationId } from "../../../hooks/useFacilityData";
import { CreateSubjectModal } from "../../../modals/general/CreateSubjectModal";
import { FacilityEditModal } from "../facility/FacilityEditView";
import {
  Avatar,
  ClickableRow,
  CountDivider,
  EmptyState,
  ListShell,
  PrimaryButton,
  RowChevron,
  RowName,
  RowSkeleton,
  SearchBar,
  ToolbarRow,
} from "./orgTabsKit";

export const OrgFacilitiesTab = ({ organisationId, orgName }) => {
  const [search, setSearch] = useState("");
  const [createOpen, setCreateOpen] = useState(false);
  const [editFacilityId, setEditFacilityId] = useState(null);

  const { data, isLoading } = GetFacilitiesByOrganisationId(organisationId);

  const facilities = useMemo(
    () => (Array.isArray(data?.data) ? data.data : []),
    [data]
  );

  const filtered = useMemo(() => {
    const q = search.trim().toLowerCase();
    if (!q) return facilities;
    return facilities.filter((f) =>
      (f.facility_name || "").toLowerCase().includes(q)
    );
  }, [facilities, search]);

  return (
    <Box>
      <ToolbarRow>
        <SearchBar
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          placeholder="Sök anläggning..."
        />
        <PrimaryButton
          icon={ApartmentRoundedIcon}
          label="Skapa anläggning"
          onClick={() => setCreateOpen(true)}
        />
      </ToolbarRow>

      <CountDivider
        label={
          isLoading
            ? "Läser in anläggningar"
            : `${filtered.length} ${
                filtered.length === 1 ? "anläggning" : "anläggningar"
              }`
        }
      />

      {isLoading ? (
        <RowSkeleton />
      ) : filtered.length === 0 ? (
        <EmptyState
          icon={ApartmentRoundedIcon}
          title={search.trim() ? "Inga träffar" : "Inga anläggningar ännu"}
          hint={
            search.trim()
              ? "Prova en annan sökterm."
              : "Skapa en anläggning för att kunna koppla grupper och användare till den."
          }
        />
      ) : (
        <ListShell>
          {filtered.map((facility) => (
            <ClickableRow
              key={facility.id}
              columns="auto 1fr auto"
              onClick={() => setEditFacilityId(facility.id)}
            >
              <Avatar name={facility.facility_name || "?"} />
              <Box sx={{ minWidth: 0 }}>
                <RowName>
                  {facility.facility_name || "Namnlös anläggning"}
                </RowName>
              </Box>
              <RowChevron />
            </ClickableRow>
          ))}
        </ListShell>
      )}

      <Dialog
        title={`Skapa anläggning · ${orgName}`}
        open={createOpen}
        onClose={() => setCreateOpen(false)}
      >
        <CreateSubjectModal
          customerid={organisationId}
          closeCreateModal={() => setCreateOpen(false)}
        />
      </Dialog>

      {editFacilityId && (
        <Dialog
          title="Redigera anläggning"
          open={!!editFacilityId}
          onClose={() => setEditFacilityId(null)}
        >
          <FacilityEditModal
            facilityId={editFacilityId}
            onClose={() => setEditFacilityId(null)}
          />
        </Dialog>
      )}
    </Box>
  );
};

export default OrgFacilitiesTab;
